import React from "react";
import { ReactAdminComponentProps, ListContextProvider } from "react-admin";
import { useCompactListController } from "../list/compact-list/useCompactListController";

export interface Sort {
  field: string;
  order: string;
}

interface Props extends ReactAdminComponentProps {
  children: React.ReactNode;
  perPage: number;
  sort: Sort;
  filter?: any;
}

export const CompactListBase = ({ children, ...props }: Props) => (
  <ListContextProvider value={useCompactListController(props)}>
    {children}
  </ListContextProvider>
);
